// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.5); /* Fondo negro semi-transparente */
    z-index: 999; /* Asegura que esté detrás del modal */
  }
  
  /* Modal: Contenedor principal */
  .modal {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: #ffffff;
    border-radius: 8px;
    box-shadow: 0 4px 8px #0000001a;
    padding: 40px;
    width: 500px;
    z-index: 1000; /* Debe estar encima de la overlay */
    height: 80vh;
    overflow-y: auto; /* Permite scroll si el contenido es muy grande */
  }

  
/* Header del Modal */
.modal h2 {
    margin-bottom: 15px;
    text-align: center;
    color: #747070;
    font-size: 16px;
  }
  
  /* Inputs, Textareas y Select */
  .modal input,
  .modal textarea,
  .modal select {
    width: 100%;
    padding: 5px;
    margin: 8px 0;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 12px;
    resize: none;
  }

.modal label{
  font-size: 12px;
}
  
/* Contenedor de Tags */
.tag-container {
    margin-bottom: 10px;
    margin-top: 10px;
    background-color: #f1f1f1;
    padding: 20px;
    border-radius: 5px;
    overflow-y: auto;
    max-height: 100px;
  }
  
  /* Estilo para cada Tag */
  .tag {
    display: inline-block;
    background-color: #79b4f4;
    color: white;
    padding: 5px 10px;
    border-radius: 15px;
    margin-right: 10px;
    margin-bottom: 5px;
    font-size: 12px;
  }
  
  .remove-tag{
    border-style: none;
    background-color:transparent;
    color: white;
    margin-left: 10px;
    padding: 0;
  }

  .remove-tag:hover{
    transform: scale(1.5);
    color: rgb(217, 31, 31);
    cursor: pointer;
  }

  /* Botón de Añadir */
.add-group-button {
    margin-top: 10px;
    padding: 10px;
    width: 50%;
    background-color: #aacaec;
    color: white;
    border: none;
    border-radius: 4px;
    font-size: 12px;
    cursor: pointer;
    transition: background-color 0.3s ease;
  }

  /* Botón de Añadir */
.add-host-button {
    margin-top: 10px;
    padding: 10px;
    width: 50%;
    background-color: #aacaec;
    color: white;
    border: none;
    border-radius: 4px;
    font-size: 12px;
    cursor: pointer;
    transition: background-color 0.3s ease;
  }


  /* Botón de Añadir */
.add-user-button {
    margin-top: 10px;
    padding: 10px;
    width: 50%;
    background-color: #aacaec;
    color: white;
    border: none;
    border-radius: 4px;
    font-size: 12px;
    cursor: pointer;
    transition: background-color 0.3s ease;
  }

  .add-user-button:hover{
    background-color: #4d86c3;
  }
  .add-group-button:hover{
    background-color: #4d86c3;
  }
  .add-host-button:hover{
    background-color: #4d86c3;
  }

  .cancel-button{
    margin-right: 25px;
    border-radius: 5px;
    padding: 8px;
  }`, "",{"version":3,"sources":["webpack://./src/components/excepciones-components/Maintenance/Maintenance-styles/modal.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,YAAY;IACZ,aAAa;IACb,oCAAoC,EAAE,kCAAkC;IACxE,YAAY,EAAE,sCAAsC;EACtD;;EAEA,gCAAgC;EAChC;IACE,eAAe;IACf,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,yBAAyB;IACzB,kBAAkB;IAClB,+BAA+B;IAC/B,aAAa;IACb,YAAY;IACZ,aAAa,EAAE,oCAAoC;IACnD,YAAY;IACZ,gBAAgB,EAAE,iDAAiD;EACrE;;;AAGF,qBAAqB;AACrB;IACI,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;IACd,eAAe;EACjB;;EAEA,+BAA+B;EAC/B;;;IAGE,WAAW;IACX,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,YAAY;EACd;;AAEF;EACE,eAAe;AACjB;;AAEA,uBAAuB;AACvB;IACI,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA,yBAAyB;EACzB;IACE,qBAAqB;IACrB,yBAAyB;IACzB,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,4BAA4B;IAC5B,YAAY;IACZ,iBAAiB;IACjB,UAAU;EACZ;;EAEA;IACE,qBAAqB;IACrB,uBAAuB;IACvB,eAAe;EACjB;;EAEA,oBAAoB;AACtB;IACI,gBAAgB;IAChB,aAAa;IACb,UAAU;IACV,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,sCAAsC;EACxC;;EAEA,oBAAoB;AACtB;IACI,gBAAgB;IAChB,aAAa;IACb,UAAU;IACV,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,sCAAsC;EACxC;;;EAGA,oBAAoB;AACtB;IACI,gBAAgB;IAChB,aAAa;IACb,UAAU;IACV,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,sCAAsC;EACxC;;EAEA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;EACd","sourcesContent":[".modal-overlay {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100vw;\r\n    height: 100vh;\r\n    background-color: rgba(0, 0, 0, 0.5); /* Fondo negro semi-transparente */\r\n    z-index: 999; /* Asegura que esté detrás del modal */\r\n  }\r\n  \r\n  /* Modal: Contenedor principal */\r\n  .modal {\r\n    position: fixed;\r\n    top: 50%;\r\n    left: 50%;\r\n    transform: translate(-50%, -50%);\r\n    background-color: #ffffff;\r\n    border-radius: 8px;\r\n    box-shadow: 0 4px 8px #0000001a;\r\n    padding: 40px;\r\n    width: 500px;\r\n    z-index: 1000; /* Debe estar encima de la overlay */\r\n    height: 80vh;\r\n    overflow-y: auto; /* Permite scroll si el contenido es muy grande */\r\n  }\r\n\r\n  \r\n/* Header del Modal */\r\n.modal h2 {\r\n    margin-bottom: 15px;\r\n    text-align: center;\r\n    color: #747070;\r\n    font-size: 16px;\r\n  }\r\n  \r\n  /* Inputs, Textareas y Select */\r\n  .modal input,\r\n  .modal textarea,\r\n  .modal select {\r\n    width: 100%;\r\n    padding: 5px;\r\n    margin: 8px 0;\r\n    border: 1px solid #ddd;\r\n    border-radius: 4px;\r\n    font-size: 12px;\r\n    resize: none;\r\n  }\r\n\r\n.modal label{\r\n  font-size: 12px;\r\n}\r\n  \r\n/* Contenedor de Tags */\r\n.tag-container {\r\n    margin-bottom: 10px;\r\n    margin-top: 10px;\r\n    background-color: #f1f1f1;\r\n    padding: 20px;\r\n    border-radius: 5px;\r\n    overflow-y: auto;\r\n    max-height: 100px;\r\n  }\r\n  \r\n  /* Estilo para cada Tag */\r\n  .tag {\r\n    display: inline-block;\r\n    background-color: #79b4f4;\r\n    color: white;\r\n    padding: 5px 10px;\r\n    border-radius: 15px;\r\n    margin-right: 10px;\r\n    margin-bottom: 5px;\r\n    font-size: 12px;\r\n  }\r\n  \r\n  .remove-tag{\r\n    border-style: none;\r\n    background-color:transparent;\r\n    color: white;\r\n    margin-left: 10px;\r\n    padding: 0;\r\n  }\r\n\r\n  .remove-tag:hover{\r\n    transform: scale(1.5);\r\n    color: rgb(217, 31, 31);\r\n    cursor: pointer;\r\n  }\r\n\r\n  /* Botón de Añadir */\r\n.add-group-button {\r\n    margin-top: 10px;\r\n    padding: 10px;\r\n    width: 50%;\r\n    background-color: #aacaec;\r\n    color: white;\r\n    border: none;\r\n    border-radius: 4px;\r\n    font-size: 12px;\r\n    cursor: pointer;\r\n    transition: background-color 0.3s ease;\r\n  }\r\n\r\n  /* Botón de Añadir */\r\n.add-host-button {\r\n    margin-top: 10px;\r\n    padding: 10px;\r\n    width: 50%;\r\n    background-color: #aacaec;\r\n    color: white;\r\n    border: none;\r\n    border-radius: 4px;\r\n    font-size: 12px;\r\n    cursor: pointer;\r\n    transition: background-color 0.3s ease;\r\n  }\r\n\r\n\r\n  /* Botón de Añadir */\r\n.add-user-button {\r\n    margin-top: 10px;\r\n    padding: 10px;\r\n    width: 50%;\r\n    background-color: #aacaec;\r\n    color: white;\r\n    border: none;\r\n    border-radius: 4px;\r\n    font-size: 12px;\r\n    cursor: pointer;\r\n    transition: background-color 0.3s ease;\r\n  }\r\n\r\n  .add-user-button:hover{\r\n    background-color: #4d86c3;\r\n  }\r\n  .add-group-button:hover{\r\n    background-color: #4d86c3;\r\n  }\r\n  .add-host-button:hover{\r\n    background-color: #4d86c3;\r\n  }\r\n\r\n  .cancel-button{\r\n    margin-right: 25px;\r\n    border-radius: 5px;\r\n    padding: 8px;\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
